import React from 'react'
import { Well } from '@pushly/aqe/lib/components'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { Select } from 'antd'
import { CatalogItemType } from '@pushly/models/lib/enums'
import { JourneyType, TriggerType } from '@pushly/models/lib/enums/journeys'
import { buildTriggerOptions } from '../../trigger-config'


export interface ITriggerSectionProps {
    trigger: {
        getConfiguration?: () => { type?: TriggerType; params?: Record<string, unknown> }
    }
    journeyType: JourneyType
    hasAbandonedViewAccess: boolean
    hasSavedItemsAccess: boolean
    domainItemType?: CatalogItemType
    onChange: (next: TriggerType) => void
    disabled?: boolean
}

export const TriggerSection: React.FC<ITriggerSectionProps> = React.memo(
    ({ trigger, journeyType, hasAbandonedViewAccess, hasSavedItemsAccess, onChange, domainItemType, disabled }) => {
        const cfg = (trigger?.getConfiguration?.() ?? {}) as { type?: TriggerType; params?: Record<string, unknown> }
        const triggerType = cfg?.type as TriggerType | undefined
        const rawItemType = (cfg?.params as any)?.item_type
        const itemType = (() => {
            // Prefer item type set on journey trigger
            if (rawItemType) {
                const rawStr = String(rawItemType).toLowerCase()
                const enumValues = Object.values(CatalogItemType) as Array<string>
                const direct = enumValues.find((v) => String(v).toLowerCase() === rawStr)
                if (direct) return direct as unknown as CatalogItemType
                const map: Record<string, CatalogItemType | undefined> = {
                    product: CatalogItemType.PRODUCT,
                    event: CatalogItemType.TICKETED_EVENT,
                    recipe: CatalogItemType.RECIPE,
                }
                return map[rawStr] ?? (domainItemType ?? CatalogItemType.PRODUCT)
            }

            // 2) Fallback to domain item type, if provided
            if (domainItemType) return domainItemType

            // 3) Final fallback to PRODUCT
            return CatalogItemType.PRODUCT
        })()


        const options = buildTriggerOptions(itemType, { hasAbandonedViewAccess, hasSavedItemsAccess }, journeyType)

        return (
            <Well mode="ghost" title="Trigger" hideFooter={true} className="entry-cap-well">
                <Form.Item
                    className="journey-trigger-editor-label"
                    label="Subscribers enter this journey after"
                    colon={false}
                >
                    <Select
                        className="journey-trigger-editor-type-selection"
                        popupClassName="journey-trigger-editor-type-dropdown"
                        size="small"
                        placeholder="Select a journey trigger"
                        value={triggerType}
                        onChange={onChange as any}
                        style={{ minWidth: 250 }}
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: 300 }}
                        disabled={disabled}
                    >
                        {options.map((o) => (
                            <Select.Option key={o.value} value={o.value}>
                                {o.label}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Well>
        )
    },
)

export default TriggerSection
